import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Popover, ClickAwayListener } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import ThinDivider from 'components/common/ThinDivider';
import { AddressTypeButton } from './OfferPartnerStyles';

const AddressTypesModal = ({ closeAddressTypesModal, addressTypes, addresses, partner, addAddress, anchor }) => {
  const onAddressTypeClick = (partner, addressType) => {
    const addressTypeToAdd = { ...addressTypes.find(addr => addr.code === addressType.code), name: addressType.name };

    if (addressTypeToAdd) addAddress(partner, addressTypeToAdd);

    closeAddressTypesModal();
  };

  const isLast = index => addresses.indexOf(addresses[addresses.length - 1]) === index;

  return (
    <Popover
      open={Boolean(anchor)}
      anchorEl={anchor}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
    >
      <ClickAwayListener onClickAway={closeAddressTypesModal}>
        <Grid container>
          <Grid item xs={12}>
            {addresses.map((item, index) => {
              return (
                <>
                  <AddressTypeButton
                    id={'offerPartnerFormCard_addressTypesModal_addressType_' + index}
                    variant='text'
                    fullWidth
                    onClick={() => onAddressTypeClick(partner, item)}
                  >
                    {item.name}
                  </AddressTypeButton>
                  {addresses.length > 0 && !isLast(index) && <ThinDivider />}
                </>
              );
            })}
          </Grid>
        </Grid>
      </ClickAwayListener>
    </Popover>
  );
};

AddressTypesModal.propTypes = {
  addressTypes: PropTypes.array.isRequired,
  addresses: PropTypes.array.isRequired,
  closeAddressTypesModal: PropTypes.func,
  partner: PropTypes.object,
  t: PropTypes.func.isRequired,
  addAddress: PropTypes.func,
  anchor: PropTypes.object
};

export default compose(withTranslation())(AddressTypesModal);
